import React, { useEffect, useState } from 'react';
import '../ProductStatusFilter.css';
import { FormControlLabel, Checkbox, Button, IconButton, Tooltip, CircularProgress } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import RefreshIcon from '@material-ui/icons/Refresh';

function ChemistOrderFilter({ handleFilters, refreshData }) {
    const { register, handleSubmit } = useForm();
    const history = useHistory();
    const [isRefreshLoading, setIsRefreshLoading] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);

    const handleChangedFilter = (data) => {
        handleFilters(data);
    }

    const handleRefreshBtn = () => {
        setIsRefreshLoading(true);
        refreshData();
        setIsRefreshLoading(false);
    }

    useEffect(() => {
        const checkTime = () => {
            const now = new Date();
            const currentHours = now.getHours();
            const currentMinutes = now.getMinutes();
            const isInDisabledTime = (currentHours === 16 && currentMinutes >= 0) || (currentHours > 16 && currentHours < 24);
            setIsDisabled(isInDisabledTime);
        };

        checkTime();
        const timer = setInterval(checkTime, 60000);

        return () => clearInterval(timer);
    }, []);

    return (
        <>
            <form onChange={handleSubmit(handleChangedFilter)}>
                <div className="allProducts__productStatusFilter">
                    <div className={`allProducts__productStatusContent allProducts__flexContent ${isDisabled && 'disabledCursor'}`}>
                        <Button 
                            variant="contained" 
                            className={`employerIndex__createPostBtn employerIndex__createProduct ${isDisabled && 'disabledCursor'}`}
                            disabled={isDisabled}
                            onClick={() => history.push('/chemist/create-order')}>Create Order</Button>
                    </div>
                    <div className="allProducts__productStatusContent">
                        <Tooltip title="Refresh with new data" placement="top">
                            <IconButton 
                                color="secondary"
                                onClick={handleRefreshBtn}>
                                {isRefreshLoading ? <CircularProgress size={16} /> : <RefreshIcon fontSize='large' />}
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>
            </form>
        </>
    )
}

export default ChemistOrderFilter
